module.exports = __webpack_public_path__ + "static/media/教学模块.81902acb.png";